import { PrintApiReceiptPrinter } from "../../receipt-printer/print-api/PrintApiReceiptPrinter";
import { PrintApiLabelPrinter } from "../../label-printer/print-api/PrintApiLabelPrinter";

export function isPrintApiPeripheral(
  peripheral: object
): peripheral is PrintApiReceiptPrinter | PrintApiLabelPrinter {
  return peripheral instanceof PrintApiReceiptPrinter || peripheral instanceof PrintApiLabelPrinter;
}
